module.exports = __webpack_public_path__ + "static/media/shape0_4.d402eae2.obj";